import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, Input, Button, Select, Space, Divider, Checkbox } from 'antd';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import {
  apiCreateDevice,
  apiGetDeviceById,
  apiUpdateDevice
} from '@services/ManageDevices/DeviceServices';
import { showSuccess } from '@components/notification';
import { SelectCommunity } from '@page/Common/SelectCommunity';

const { Title } = Typography;

const validationSchema = Yup.object({
  imei: Yup.string().required('Trường này là bắt buộc'),
  serial_no: Yup.string().required('Trường này là bắt buộc'),
  // customer_id: Yup.string().required('Trường này là bắt buộc'),
  imsi: Yup.string().required('Trường này là bắt buộc'),
  iccid: Yup.string().required('Trường này là bắt buộc'),
  model: Yup.string().required('Trường này là bắt buộc')
});

export const Add = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [device, setDevice] = useState({});
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      id ? await apiUpdateDevice(values, id) : await apiCreateDevice(values);
      showSuccess({ message: 'Thành công!' });
      navigate('/devices');
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetch = async () => {
    try {
      setLoadingFetch(true);
      const res = await apiGetDeviceById(id);
      if (res) {
        setDevice(res?.data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingFetch(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [id]);

  return (
    <>
      <Card
        title={id ? 'Cập nhật thiết bị' : 'Thêm mới thiết bị'}
        loading={loadingFetch}
        headStyle={{ backgroundColor: '#0051A9', color: '#FFF' }}
        bodyStyle={{ padding: '24px', paddingTop: '0px' }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Formik
              enableReinitialize
              initialValues={{
                serial_no: device?.serial_no ?? '',
                imei: device?.imei ?? '',
                imsi: device?.imsi ?? '',
                iccid: device?.iccid ?? '',
                customer_id: device?.customer_id ?? '',
                model: device?.model ?? '',
                community: device?.community ?? 'HP'
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}>
              {({ setFieldValue, values }) => (
                <Form>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>Số serie (*)</Title>
                      <Field name="serial_no">
                        {({ field }) => <Input {...field} placeholder="Nhập mã thiết bị" />}
                      </Field>
                      <ErrorMessage name="serial_no" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={6} xs={12}>
                      <Title level={5}>IMEI (*)</Title>
                      <Field name="imei">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập IMEI"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="imei" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>IMSI (*)</Title>
                      <Field name="imsi">
                        {({ field }) => <Input {...field} placeholder="Nhập imsi" />}
                      </Field>
                      <ErrorMessage name="imsi" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={6} xs={12}>
                      <Title level={5}>ICCID (*)</Title>
                      <Field name="iccid">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập iccid"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="iccid" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>Model (*)</Title>
                      <Field name="model">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập model"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="model" component="div" style={{ color: 'red' }} />
                    </Col>
                    {/* <Col md={6} xs={12}>
                      <Title level={5}>Mã khách hàng1 (*)</Title>
                      <Field name="customer_id">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập mã khách hàng"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="customer_id" component="div" style={{ color: 'red' }} />
                    </Col> */}
                    {/* <Col md={6} xs={12}>
                      <Title level={5}>Nhà máy (*)</Title>
                      <Field name="community">
                        {({ field }) => (
                          <SelectCommunity
                            {...field}
                            value={values?.community}
                            onChange={(value) => setFieldValue('community', value)}
                            isAll={false}
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="community" component="div" style={{ color: 'red' }} />
                    </Col> */}
                  </Row>
                  <Divider style={{ marginTop: '32px' }} />
                  <Row gutter={[16, 16]}>
                    <Col>
                      <Space size={16}>
                        <Button
                          type="primary"
                          onClick={() => navigate(-1)}
                          style={{
                            color: '#fff',
                            backgroundColor: '#ff9800',
                            height: '36px'
                          }}>
                          Quay lại
                        </Button>
                        <Button
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          style={{ backgroundColor: '#0051A9', height: '36px' }}>
                          {id ? 'Cập nhật' : 'Thêm mới'}
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Card>
    </>
  );
};
